<ng-container *ngFor="let row of rows; let i = index; trackBy: trackRow">
  <ng-container *ngIf="row.selected">
    <tr (click)="editRow(i)" [class]="getRowCssClasses(row, i)">

      <ng-container *ngIf="editMode">
        <td [attr.colspan]="row.leftColspan || leftColspan" (click)="$event.stopPropagation()" *ngIf="!row.isCustom && row.leftColspan !== 0">

          <div *ngIf="!row.isCustomLabelRow" (click)="editRow(i)">
            <kendo-dropdownlist [data]="reflists[topicReflist]" style="width:100%" class="widget-input-text"
                                textField="description"
                                valueField="oid"
                                [valuePrimitive]="true"
                                [(ngModel)]="row.topicId"
                                [itemDisabled]="wrapIsTopicSelectionDisabled(this)"
                                (valueChange)="onRowTopicChanged(row, $event)"
                                [popupSettings]="popupSettings"
                                [listHeight]="listHeight">
            </kendo-dropdownlist>
          </div>

          <div *ngIf="row.isCustomLabelRow && customLabelsDefinitionsObject[row.fieldName]" (click)="editRow(i)" class="d-flex">
            <input class="widget-input-text customLabel" maxlength="65535"
                   hashtag [selectedTag]="selectedTag" [widgetId]="widgetId" [widget]="widget"
                   [page]="page" [editMode]="editMode" id="{{row.fieldName}}{{i}}"
                   (setNewValue)="customLabelsDefinitionsObject[row.fieldName].customLabel= $event;setDirtyFlag(true)" [(ngModel)]="customLabelsDefinitionsObject[row.fieldName].customLabel" (ngModelChange)="setDirtyFlag(true)" />
          </div>

        </td>
        <td [attr.colspan]="row.leftColspan || leftColspan" class="text-and-list-view-mode-row" *ngIf="row.isCustom">
          <widget-value [align]="'left'" [bold]="true">{{ row.topicId | rdReflist: reflists[topicReflist] }}</widget-value>
        </td>

        <td *ngIf="!rightColumnsTemplate" [attr.colspan]="row.rightColspan || rightColspan" (click)="$event.stopPropagation()" class="gridster-item-content">

          <div *ngIf="!row.isCustomLabelRow && row.isTextField && !row.readonly && !row.isTextArea" class="d-flex" (click)="editRow(i)">
            <input class="widget-input-text" [attr.maxlength]="getMaxLength(row)"
                   hashtag [selectedTag]="selectedTag" [widgetId]="widgetId" [widget]="widget"
                   [page]="page" [editMode]="editMode" id="{{row.fieldName}}{{i}}"
                   (setNewValue)="data[row.fieldName]= $event;setDirtyFlag(true)"[(ngModel)]="data[row.fieldName]" (ngModelChange)="setDirtyFlag(true)" />
          </div>

          <div *ngIf="!row.isCustomLabelRow && row.isTextField && !row.readonly && row.isTextArea" class="d-flex" (click)="editRow(i)">
            <textarea class="widget-input-text" hashtag [selectedTag]="selectedTag" [widgetId]="widgetId" [widget]="widget"
                      [page]="page" [editMode]="editMode" id="{{row.fieldName}}{{i}}"
                      (setNewValue)="data[row.fieldName]= $event;setDirtyFlag(true)"[attr.maxlength]="getMaxLength(row)" [attr.rows]="getTextAreaRows(row)" [(ngModel)]="data[row.fieldName]" (ngModelChange)="setDirtyFlag(true)"></textarea>
          </div>

          <div *ngIf="!row.isCustomLabelRow && row.isTextField && row.readonly" class="d-flex" (click)="editRow(i)">
            <widget-value [align]="'left'">{{data[row.fieldName]}}</widget-value>
          </div>

          <div *ngIf="row.isCustomLabelRow && customLabelsDefinitionsObject[row.fieldName]" class="d-flex" (click)="editRow(i)">
            <input class="widget-input-text" hashtag [selectedTag]="selectedTag" [widgetId]="widgetId" [widget]="widget"
                   [page]="page" [editMode]="editMode" id="{{row.fieldName}}{{i}}"
                   (setNewValue)="customLabelsDefinitionsObject[row.fieldName].stringValue= $event;setDirtyFlag(true)" maxlength="65535" [(ngModel)]="customLabelsDefinitionsObject[row.fieldName].stringValue" (ngModelChange)="setDirtyFlag(true)" />
          </div>

          <div *ngIf="row.isDateField && !row.readonly" class="d-flex" (click)="editRow(i)">
            <pollux-report-designer-date-field class="widget-input-text" ngDefaultControl [(ngModel)]="data[row.fieldName]" (ngModelChange)="setDirtyFlag(true)"></pollux-report-designer-date-field>
          </div>
          <div *ngIf="row.isDateField && row.readonly" class="d-flex" (click)="editRow(i)">
            <widget-value style="width: 100%;" [align]="'right'">{{ data[row.fieldName] | rdLocalizedDate}}</widget-value>
          </div>

          <div *ngIf="row.isNumericField && !row.readonly" class="d-flex" (click)="editRow(i)">
            <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="data[row.fieldName]" [isNullable]="true" [decimals]="row.decimals || 0" [thousandsSeparators]="row.thousandsSeparators" (valueChange)="setDirtyFlag(true)"></pollux-report-designer-numeric-field>
          </div>
          <div *ngIf="row.isNumericField && row.readonly" class="d-flex" (click)="editRow(i)">
            <widget-value style="width: 100%;" [align]="'right'"><span *ngIf="row.isCurrency">{{currency}} </span>{{ data[row.fieldName] | rdLocalizedNumber:0}}<span *ngIf="row.isArea">{{unitOfArea}}</span></widget-value>
          </div>

          <div *ngIf="row.isSingleSelectField && !row.readonly" (click)="editRow(i)">
            <kendo-dropdownlist [data]="reflists[row.reflistName]" style="width:100%" class="widget-input-text"
                                textField="description"
                                valueField="oid"
                                [valuePrimitive]="true"
                                [(ngModel)]="data[row.fieldName]"
                                (ngModelChange)="setDirtyFlag(true)">
            </kendo-dropdownlist>
          </div>
          <div *ngIf="row.isSingleSelectField && row.readonly" (click)="editRow(i)">
            <widget-value [align]="'right'">{{ data[row.fieldName] | rdReflist: reflists[row.reflistName] }}</widget-value>
          </div>
          <div *ngIf="row.isCustom" style="width: 100%; height: 100%;">
            <ng-content select="[text-and-list-edit-mode]"></ng-content>
          </div>
        </td>

        <ng-container *ngIf="rightColumnsTemplate">
          <ng-container *ngTemplateOutlet="rightColumnsTemplate; context: {$implicit: row, index: i, data: data, textAndListInstance: textAndListInstance}"></ng-container>
        </ng-container>

      </ng-container>

      <ng-container *ngIf="!editMode">
        <td [attr.colspan]="row.leftColspan || leftColspan" class="text-and-list-view-mode-row" *ngIf="!row.isCustomLabelRow && !row.isCustom && row.leftColspan !== 0">
          <widget-value [align]="'left'">{{ row.topicId | rdReflist: reflists[topicReflist] }}</widget-value>
        </td>
        <td [attr.colspan]="row.leftColspan || leftColspan" class="text-and-list-view-mode-row" *ngIf="!row.isCustomLabelRow && row.isCustom && row.leftColspan !== 0">
          <widget-value [align]="'left'" [bold]="true">{{ row.topicId | rdReflist: reflists[topicReflist] }}</widget-value>
        </td>
        <td [attr.colspan]="row.leftColspan || leftColspan" class="text-and-list-view-mode-row" *ngIf="row.isCustomLabelRow && customLabelsDefinitionsObject[row.fieldName] && row.leftColspan !== 0">
          <widget-value [align]="'left'"> <label hashtagsetvalue [widget]="widget" [page]="page">{{customLabelsDefinitionsObject[row.fieldName].customLabel }}</label></widget-value>
        </td>

        <td *ngIf="!rightColumnsTemplate" [attr.colspan]="row.rightColspan || rightColspan" class="text-and-list-view-mode-row">
          <widget-value *ngIf="row.isTextField && !row.isCustomLabelRow && !row.isTextArea" [align]="getRightColumnAlign(row)"><label hashtagsetvalue [widget]="widget" [page]="page">{{data[row.fieldName]}}</label></widget-value>
          <widget-value *ngIf="row.isTextField && !row.isCustomLabelRow && row.isTextArea" [align]="getRightColumnAlign(row)"><div [innerHTML]="getTextAreaHtml(data[row.fieldName])"></div></widget-value>
          <widget-value *ngIf="row.isTextField && row.isCustomLabelRow && customLabelsDefinitionsObject[row.fieldName]" [align]="getRightColumnAlign(row)"><label hashtagsetvalue [widget]="widget" [page]="page">{{customLabelsDefinitionsObject[row.fieldName].stringValue}}</label></widget-value>
          <widget-value *ngIf="row.isDateField" [align]="getRightColumnAlign(row)">{{ data[row.fieldName] | rdLocalizedDate}}</widget-value>
          <widget-value *ngIf="row.isNumericField" [align]="getRightColumnAlign(row)"><span *ngIf="row.isCurrency">{{currency}} </span>{{ data[row.fieldName] | rdLocalizedNumber:(row.decimals || 0)}}<span *ngIf="row.isArea">{{unitOfArea}}</span><span *ngIf="row.isPercentage">%</span></widget-value>
          <widget-value *ngIf="row.isSingleSelectField" [align]="getRightColumnAlign(row)">{{ data[row.fieldName] | rdReflist: reflists[row.reflistName] }}</widget-value>
          <div *ngIf="row.isCustom" style="width: 100%; height: 100%;">
            <ng-content></ng-content>
          </div>
        </td>

        <ng-container *ngIf="rightColumnsTemplate">
          <ng-container *ngTemplateOutlet="rightColumnsTemplate; context: {$implicit: row, index: i, data: data, textAndListInstance: textAndListInstance}"></ng-container>
        </ng-container>

      </ng-container>

    </tr>
  </ng-container>
</ng-container>
